/* PRODUCT form (spec §4.5, §5.16, §5.18). Never computes money. Gallery + sticky bar: product-media.js */
(() => {
const S = (window.Sunsnub = window.Sunsnub || {});
if (S.productJs) return;
S.productJs = 1;
const d = document;
const rm = () => (S.reducedMotion ? S.reducedMotion() : matchMedia('(prefers-reduced-motion: reduce)').matches);
const str = (k, f) => (S.strings && S.strings[k]) || f;
const emit = (n, detail) => d.dispatchEvent(new CustomEvent(n, { detail }));
const same = (x, el) => x && String(x.productId) === el.dataset.productId;
const on = (n, f) => d.addEventListener(n, f);
const off = (n, f) => f && d.removeEventListener(n, f);
const KEYS = { atc_main: 'atcMain', box_line: 'boxLine' };

class ProductForm extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    try { this.data = JSON.parse(this.querySelector('[data-pack-data]').textContent); } catch (e) { return; }
    this.ready = 1;
    const q = (s) => this.querySelector(s);
    [this.form, this.idEl, this.atc, this.err, this.note] = ['form', '[data-pf-id]', '[data-pf-atc]', '[data-form-error]', '.packs__note'].map(q);
    this.addEventListener('change', (e) => e.target.matches('.pack__input') && this.select(e.target.value));
    this.form.addEventListener('submit', (e) => this.submit(e));
    this.onChange = (e) => same(e.detail, this) && e.detail.sourceId !== this.id && this.select(e.detail.variantId, { silent: true });
    on('pack:change', this.onChange);
    const c = q('.pack__input:checked');
    if (c && c.value !== this.idEl.value) this.select(c.value, { silent: true });
    if (this.hasAttribute('data-primary') || (!d.querySelector('[data-primary]') && d.querySelector('ss-product-form') === this)) {
      this.onSelect = (e) => this.packSelect(e.detail || {});
      on('pack:select', this.onSelect);
      requestAnimationFrame(() => this.emitChange(this.variant()));
    }
  }
  disconnectedCallback() {
    off('pack:change', this.onChange);
    off('pack:select', this.onSelect);
    this.ready = 0;
  }
  variant(id) {
    const k = String(id || this.idEl.value);
    return this.data.variants.find((v) => String(v.id) === k);
  }
  select(id, o = {}) {
    const v = this.variant(id);
    if (!v) return;
    this.idEl.value = v.id;
    this.querySelectorAll('.pack').forEach((l) => {
      const i = l.querySelector('.pack__input');
      i.checked = i.value === String(v.id);
      l.classList.toggle('is-selected', i.checked);
    });
    this.querySelectorAll('[data-pf]').forEach((el) => {
      const k = el.dataset.pf;
      const val = v.strings[KEYS[k] || k];
      if (val == null) return;
      el.textContent = val;
      if (k === 'saving') el.hidden = !val;
    });
    /* the pre-selection note only describes the default pack */
    if (this.note) this.note.hidden = String(v.id) !== this.dataset.defaultId;
    if (this.atc) this.atc.disabled = !v.available;
    this.label();
    this.hideError();
    if (this.hasAttribute('data-update-url')) {
      const u = new URL(location.href);
      if (u.searchParams.get('variant') !== String(v.id)) {
        u.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', u);
      }
    }
    if (!o.silent) this.emitChange(v);
  }
  label() {
    const v = this.variant();
    const m = this.atc && this.atc.querySelector('[data-pf="atc_main"]');
    if (v && m) m.textContent = v.available ? v.strings.atcMain : str('soldOut', 'Sold out');
  }
  emitChange(v) {
    if (!v) return;
    const { id: variantId, maskCount, available, mediaId, strings } = v;
    emit('pack:change', { productId: this.data.productId, variantId, maskCount, available, mediaId, strings, sourceId: this.id });
  }
  packSelect(x) {
    if (x.productId && !same(x, this)) return;
    const v = x.variantId ? this.variant(x.variantId) : this.data.variants.find((w) => w.maskCount == x.maskCount);
    if (!v) return;
    this.select(v.id);
    if (S.toast) S.toast(str('packSelected', '__PACK__ selected').replace('__PACK__', v.strings.name));
    const focus = () => { const r = this.querySelector('.pack__input:checked'); if (r) r.focus({ preventScroll: true }); };
    if (x.scroll === false) return focus();
    this.scrollIntoView({ behavior: rm() ? 'auto' : 'smooth', block: 'start' });
    setTimeout(focus, rm() ? 0 : 700);
  }
  async submit(e) {
    e.preventDefault();
    const btn = this.atc;
    const v = this.variant();
    if (!btn || !v || !v.available || btn.getAttribute('aria-disabled') === 'true') return;
    const sub = e.submitter !== btn ? e.submitter : null;
    const busy = (b) => [btn, sub].forEach((x) => {
      if (!x) return;
      x.setAttribute('aria-disabled', String(b));
      x.classList.toggle('is-loading', b);
    });
    busy(true);
    btn.querySelector('[data-pf="atc_main"]').textContent = str('adding', 'Adding…');
    this.hideError();
    const r = S.routes || {};
    const cfg = S.fetchConfig ? S.fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json' } };
    const body = JSON.stringify({ id: v.id, quantity: 1, sections: 'cart-drawer', sections_url: location.pathname });
    try {
      const res = await fetch(`${r.cartAdd || '/cart/add'}.js`, { ...cfg, body });
      const data = await res.json().catch(() => ({}));
      /* only Shopify's own description is shown; network errors and bare 422s get our generic string */
      if (!res.ok) throw Object.assign(new Error(data.description || ''), { api: 1 });
      emit('cart:updated', { source: 'product-form', sections: data.sections });
      if ((S.settings && S.settings.cartType === 'page') || !S.openCartDrawer) location.href = r.cart || '/cart';
      else S.openCartDrawer(sub || btn);
    } catch (err) {
      const message = (err.api && err.message) || str('error', 'Something went wrong. Please try again.');
      if (this.err) {
        this.err.textContent = message;
        this.err.hidden = false;
      }
      emit('cart:error', { source: 'product-form', message, inline: !!this.err });
    } finally {
      busy(false);
      this.label();
    }
  }
  hideError() {
    if (this.err) this.err.hidden = !(this.err.textContent = '');
  }
}

customElements.get('ss-product-form') || customElements.define('ss-product-form', ProductForm);
on('shopify:block:select', (e) => e.target.tagName === 'DETAILS' && (e.target.open = true));
})();
